import React from "react";
import Modal from "../../../../../../components/modal";
import { useDispatch, useSelector } from "react-redux";
import './index.css'
import { resetTeamsByTournament, selectTeamFromTournament } from "../../../../../../redux/actions/teams";
import { secureUrl } from "../../../../../../utils/sortArray/secureUrl";

const TeasmSelectorModal = ()=>{
    const teams = useSelector(state => state?.teams?.teamsByTournament)
    const dispatch = useDispatch()
    return(
        <Modal>
            <div className="teams-selector-modal">
                <div onClick={()=> dispatch(selectTeamFromTournament(null))} className="team-selector-modal-item-all"><p>Todos</p></div>
                {
                    teams?.map(team =>(
                        <div onClick={()=> dispatch(selectTeamFromTournament(team))} style={{margin:'10px', cursor:'pointer'}}>
                            <img style={{borderRadius:'100%'}} src={secureUrl(team?.pictureTeam)} /> 
                        </div>
                    ))
                }
            </div>

        </Modal>
    )
}

export default TeasmSelectorModal